import { render, staticRenderFns } from "./FormProfit.vue?vue&type=template&id=1bd1d9f8&"
import script from "./FormProfit.vue?vue&type=script&lang=js&"
export * from "./FormProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports